import { memo } from 'react';

import { merge } from '@/components';
import { Button, ButtonProps, Text } from '@/components/core';
import { DEFAULT_TEMPLATE, TEMPLATES } from '@/components/ui';
import { TemplateThumbnail } from '@/features/agents';
import { OmitChildren } from '@/utils';

export type TemplateCardProps = OmitChildren<ButtonProps> & {
  template: keyof typeof TEMPLATES;
  isSelected?: boolean;
};

const ITemplateCard = ({ template, isSelected, className, ...rest }: TemplateCardProps) => {
  return (
    <Button
      className={merge(
        'hover:bg-success-50 flex h-30 w-26 flex-col items-center rounded-lg bg-gray-100',
        isSelected && 'border-success-300 !bg-success-50 border',
        className
      )}
      variant="plain"
      {...rest}
    >
      <TemplateThumbnail template={template} />
      <Text className="text-xs font-semibold">{template === DEFAULT_TEMPLATE ? 'Custom' : template}</Text>
    </Button>
  );
};

export const TemplateCard = memo(ITemplateCard) as typeof ITemplateCard;
